<template>
    <div >
        <HeaderTopComponent  v-if="!menuMovil"  id='products'/>
        <MenuComponent 
            background='' 
            :dense='false' 
            styleRow='margin-top: 0px'
            v-if="!menuMovil"
        />
        <MenuMovilComponent v-if="menuMovil" class='px-6 px-sm-10 '/>
        <BreadCrumbsComponent :breadcrumbs="breadcrumbs" class="margin-breadcrumb mt-180"/>
        <div 
            v-if="$route.path=='/medicamentos-especialidad' || $route.path==`/medicamentos-especialidad/${productText}`"
            class="mx-5 mx-sm-10 mx-md-16 px-md-16 mb-16 pb-md-16">
            <div>
                <v-img 
                    v-if="$route.query.lab != undefined" 
                    :src="require(`@/assets/${$route.query.lab}${$vuetify.breakpoint.name == 'sm' || $vuetify.breakpoint.name == 'xs' ? '-small.png': '.jpg' }`)"
                    :alt=$route.query.lab
                />
                <v-row>
                    <v-col cols="12" v-if="$vuetify.breakpoint.width < 959">
                        <v-text-field
                            v-model=productText2
                            placeholder="Busque su medicina o producto aquí"
                            outlined
                            single-line
                            dense
                            rounded
                            append-icon="mdi-magnify"
                            background-color="white"
                            flat
                            hide-details
                            id="input-index-search"
                            @keydown.enter="redirectShoppingCar"
                            @click:append="redirectShoppingCar"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" md=2 class='mt-3' v-if="$vuetify.breakpoint.width > 959"> 
                        <label class='gray--text mt-2 mr-2 font-title font-weight-black'><i>Principio Activo</i></label>
                        <v-autocomplete
                            v-model="activePrinciple"
                            :items="activePrinciples"
                            item-text="prin_act"
                            item-value="principio_activo_id"
                            outlined
                            rounded
                            dense
                            class='filter'                    
                            @change="getProducts(true)"
                            clearable
                        >
                            <template v-slot:label>
                                <span class='gray--text font-title font-weight-black'> <i>Seleccione</i></span>
                            </template>
                        </v-autocomplete>
                        <div class="mt-1 mb-1">
                            <h4 class='gray--text font-title font-weight-black'><b><i>Especialidades</i></b></h4>
                        </div>   
                        <v-list dense class='py-0'>
                            <v-list-item class='px-0' v-for="(esp , x) in specialties" :key=x>
                                <v-list-item-content class='py-0'>
                                    <v-list-item-title 
                                        class="gray--text font-text font-weight-regular link"
                                        :style="`cursor:pointer;${categoryName == esp.category_name ? 'color:#50c995!important': ''}`"
                                        @click='searchCategory(esp.product_category_id)'
                                    >
                                        {{esp.category_name}} <b>({{esp.total_items}})</b>
                                    </v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                    </v-col>
                    <v-col v-else>
                        <v-expansion-panels  v-model="panel" flat class="px-1">
                            <v-expansion-panel class='px-0 pb-0' >
                                <v-expansion-panel-header  disable-icon-rotate class="px-0">
                                    <template v-slot:actions >
                                        <v-btn color='primary' small elevation="0" >
                                            <v-icon color='white'> mdi-filter-outline </v-icon> Filtros
                                        </v-btn>
                                    </template>                                    
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <label class='gray--text mt-2 mr-2 font-title font-weight-black'><i>Principio Activo</i></label>
                                    <v-autocomplete
                                        v-model="activePrinciple"
                                        :items="activePrinciples"
                                        item-text="prin_act"
                                        item-value="principio_activo_id"
                                        outlined
                                        rounded
                                        dense
                                        class='filter'                    
                                        @change="getProducts(true)"
                                        clearable
                                    >
                                        <template v-slot:label>
                                            <span class='gray--text font-title font-weight-black'> <i>Seleccione</i></span>
                                        </template>
                                    </v-autocomplete>
                                    <div class="mt-1 mb-1">
                                        <h4 class='gray--text font-title font-weight-black'><b><i>Especialidades</i></b></h4>
                                    </div>
                                    <v-list dense class='py-0'>
                                        
                                        <v-list-item class='px-0' v-for="(esp , x) in specialties" :key=x>
                                            <v-list-item-content class='py-0'>
                                                
                                                <v-list-item-title 
                                                    class="gray--text font-text font-weight-regular link"
                                                    :style="`cursor:pointer;${categoryName == esp.category_name ? 'color:#50c995!important': ''}`"
                                                    @click='searchCategory(esp.product_category_id)'
                                                >
                                                    {{esp.category_name}} <b>({{esp.total_items}})</b>
                                                </v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </v-list>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-expansion-panels>
                    </v-col>
                    <v-col cols="12" md=10 >
                        <v-col 
                            cols="12" 
                            class='pt-0' 
                        >
                            <v-overlay :value="overlay">
                                <v-progress-circular
                                    indeterminate
                                    size="64"
                                ></v-progress-circular>
                            </v-overlay>
                            <h4 v-if="$route.query.lab != undefined">
                                <a href='/medicamentos-especialidad'>Ver todos los productos</a>
                            </h4>
                            <v-row>
                                <v-col 
                                    class='pt-0 mb-15'
                                    cols=12 
                                    sm=6 md=3 
                                    v-for="(prd, x) in products" 
                                    :key=x
                                >
                                    <router-link 
                                        class='text-decoration-none' 
                                        :to="`/medicamentos-especialidad/producto/${prd.url_product}`"
                                    >
                                        <img 
                                            :src="`${!!prd.medium_image_url ? (urlApi+pathFileProducts+prd.medium_image_url) : ''}`" 
                                            style="max-width:100%" 
                                            class='p-0 border-product'
                                            :alt=prd.product_name_web
                                        >
                                        
                                    </router-link>
                                    <div class='text-center border-div'>
                                        <!-- <h5 class="px-1 px-md-2 font-title font-weight-black grayblack--text">
                                            {{prd.internal_name}}
                                        </h5> -->
                                        <div class="px-1 px-md-2 grayblack--text font-title" style="height: 100px;" v-html="prd.product_name_web"></div>
                                        <v-btn 
                                            rounded 
                                            outlined 
                                            color="orange"
                                            class='btn-quote font-title font-weight-black'
                                            @click=addItem(prd)
                                        >
                                            COTIZAR ${{parseFloat(prd.price).toFixed(2)}}
                                        </v-btn>
                                    </div>
                                    
                                </v-col>
                            </v-row>
                            <v-pagination
                                class='mt-10'
                                v-model=currentPage
                                :length=totalItems
                                @input="handlePageChange"
                                total-visible="10"
                            ></v-pagination>
                        </v-col>
                    </v-col>   
                        <v-row>
                        <div  class='mb-16 mt-10 col-12'>
                            <v-col class='secction-other-products font-title font-italic' style="position: absolute;left:0">
                                <v-col style='margin: 0 auto;width: 87%;'>
                                    <div class='text-h5 text-md-h4 font-weight-black'>
                                        Productos basados en su última visita:
                                    </div >
                                </v-col>
                            </v-col>
                        </div>
                        <v-col class=" mt-10">
                            <LastProductsVisitedComponent />
                        </v-col>
                    </v-row> 
                </v-row>
                <v-dialog
                    v-model="dialog"
                    width="700"
                    persistent
                >
                    <v-card>
                        <v-card-text class="text-center">
                            <v-col class='text-md-h6 primary--text font-weight-black' color=''>
                                <i> <v-icon class='primary--text'>mdi-check-circle-outline mdi-36px</v-icon> 
                                El producto seleccionado se agregó a la cotización</i>
                            </v-col>
                            <v-row
                                align='center'
                                justify="center"
                            >
                                <v-col cols=12 sm=7 style="border: 2px solid silver;" class="rounded-lg">
                                    <v-row
                                        align='center'
                                        justify="center"
                                    >
                                        <v-col cols="12" sm=6 class='px-sm-0 px-md-3'>
                                            <img 
                                                :src="`${!!selectProduct.images ? (urlApi+pathFileProducts+selectProduct.images) : ''}`" 
                                                style="max-width:100%" 
                                                :alt=selectProduct.product_name
                                            >
                                        </v-col>
                                        <v-col cols="12" sm=6>
                                            <div style="line-height:1" class="text-left font-weight-black" v-html=selectProduct.product_name></div>
                                            <div style='border:2px solid #50c995' class="rounded-xl text-caption mt-5">
                                                Cantidad 
                                                <v-icon class="primary--text px-2" @click="quantity('-')">mdi-minus mdi-18px</v-icon> 
                                                <span class='font-weight-bold gray--text'>{{selectProduct.quantity}}</span>
                                                <v-icon class="primary--text px-2" @click="quantity('+')">mdi-plus mdi-18px</v-icon>
                                            </div>
                                        </v-col>
                                    </v-row>
                                </v-col>
                                <v-col cols=12 sm=5>
                                    <em class="font-text gray--text "><b><i>Hay {{totalQuantity}} poductos en  tu cotización</i></b></em>
                                    <div>
                                        <v-btn
                                            rounded 
                                            outlined 
                                            color="orange"
                                            class='font-title font-weight-black my-3 text-md-subtitle-1 text-capitalize px-5'
                                            @click="dialog=false"
                                        >
                                            <b><i>Seguir agregando</i></b>
                                        </v-btn>
                                    </div>
                                    <div>
                                        <v-btn 
                                            color='blue' 
                                            rounded 
                                            class='font-title white--text text-capitalize text-md-subtitle-1 px-6'
                                            to='/medicamentos-especialidad/cotizacion'
                                        >
                                            <b><i>Completar compra</i></b>
                                        </v-btn>
                                    </div>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols=12 clas="text-center">
                                    <v-btn small color="primary" class="mx-2" @click="dialog= !dialog" >
                                        <v-icon >mdi-cancel</v-icon> Cerrar
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-dialog>
            </div>
        </div>
        <router-view></router-view>
        <FooterComponent />
    </div>
</template>

<script>
import axios from 'axios'
import {mapActions, mapMutations, mapState} from 'vuex'
import CheckoutProductsComponent from '../partials/CheckoutProductsComponent'
import MenuMovilComponent from '../partials/MenuMovilComponent'
import HeaderTopComponent from '../partials/HeaderTopComponent'
import MenuComponent from '../partials/MenuComponent'
import FooterComponent from '../partials/FooterComponent'
import BreadCrumbsComponent from '../partials/BreadCrumbsComponent'
import LastProductsVisitedComponent from '../partials/LastProductsVisitedComponent'

export default {
    metaInfo () {
        return {
            title: `GRUPO INNOFARM - ${this.titlePage}`,
            bodyAttrs: {
                class: 'child-component'
            },
            afterNavigation () {
               // metaUpdated = 'yes'
            }
        }
    },
    name:'DrugCatalogsComponent',
    components:{
        CheckoutProductsComponent,
        MenuMovilComponent,
        HeaderTopComponent,
        MenuComponent,
        FooterComponent,
        BreadCrumbsComponent,
        LastProductsVisitedComponent
    },
    data:()=>({
        breadcrumbs:[
            {name:'Inicio',url:'/'},
            {name:'Medicamentos de especialidad',url:'/medicamentos-especialidad'}
        ],
        titlePage:'MEDICINA DE ESPECIALIDAD',
        totalItems:1,
        currentPage:1,
        brand:null,
        created:false,
        activePrinciple:null,
        administration:null,
        speciality:null,
        product:null,
        dialog:false,
        order:'alphabet',
        overlay:false,
        tab: null,
        productId:null,
        productText:null,
        productText2:null,
        categoryName:null,
        panel: '',
        selectProduct:{
            product_id:null,
            quantity:0,
            product_name:'',
            images:[]
        },
        orderBy:[
            {name:'Nombre A-Z',value:'alphabet'}
        ],
        itemsPerPage:[4,8,12,24],
        brands:[],
        activePrinciples:[],
        administrations:[],
        specialties:[],
        products:[],
        cantCarrousel:0,
        productsComplement:[],
    }),
    computed:{

        ...mapState(['loadingTable','urlApi','totalQuantity','pathFileProducts','selectedProducts','lastProductsVisited']),

        menuMovil(){
            return this.$vuetify.breakpoint.name == 'sm' || this.$vuetify.breakpoint.name == 'xs'
        },
        
    },
    watch:{

        overlay: function(val){
            if(this.$vuetify.breakpoint.name !='sm' || this.$vuetify.breakpoint.name!='xs')
                !val && this.$vuetify.goTo('#products',0)
        },

        productText: function(){
            this.getProducts()
        },
        
    },
    methods:{

        ...mapMutations(['setUrl','setLoadingTable','itemShoppingCar','setTotalQuantity','setSelectedProducts','setLastProductsVisited']),

		...mapActions(['requestApi','dataCarousel']),

        getDataAutocomplete(){
            const principioActivo = axios.get(this.urlApi+'ecommcat?tipo=pa')
            const especialidades = axios.get(this.urlApi+'ecommcat?tipo=esp')
            //const listBrand = axios.get(this.urlApi+'ecommcat?tipo=lab')
            //const adminsitracion = axios.get(this.urlApi+'ecommcat?tipo=ff')
            // const prodcutos = axios.get('http://192.168.1.49:3333/busqueda-catalogo')
            
            const requests= [principioActivo, especialidades/* listBrand, adminsitracion, /* ,prodcutos */]
            axios.all(requests)
            .then( response => {
                this.specialties = response[1].data._embedded.categorias
                this.activePrinciples= response[0].data._embedded.categorias
                //this.products = response[4].data._embedded.busqueda_catalogo
                //this.brands= response[0].data._embedded.categorias
                //this.administrations = response[2].data._embedded.categorias
            })
        },

        getProducts(category,pagination=false){
            if(!category){
                this.speciality=''
                this.activePrinciple=''
            }                
            
            ///if(this.currentPage>1 && this.productText!='' && this.productText!=null && !pagination &&  this.speciality!='')
                //this.currentPage=1
               
            if(this.currentPage > 1 && this.productText!='' && this.productText!=null && !pagination)
                this.currentPage=1

            this.overlay=true
            this.productId=null
            this.setUrl('busqueda-catalogo')
            this.requestApi({
				method: 'GET',
				data :{
                    page:this.currentPage,
                    pagesize:'12',
                    esp: this.speciality, // especialidad
                    pac: this.activePrinciple, //principio activo
                    product_name_web: this.productText,
                    lab: this.$route.query.lab       
                }
			}).then(res =>{
                this.totalItems = res.data.page_count
                this.products = res.data._embedded.busqueda_catalogo
                this.overlay=false
			}).catch(()=>{
                
            }).then(()=>{
                this.overlay=false
            })
            
        },

        handlePageChange(value) {
            this.currentPage = value;
            this.getProducts(true,true)
        },

        addItem(item){
          
            this.dialog=true
           
            let itemExist = this.selectedProducts.find(e => e.product_id == item.product_id)
            this.selectProduct.quantity=1
            this.selectProduct.product_id = item.product_id 
            
            if(typeof itemExist !='undefined'){

                let index = this.selectedProducts.indexOf(itemExist)
                this.selectProduct.quantity = this.selectedProducts[index].quantity

            }else{
                this.setSelectedProducts({
                    product_id: item.product_id,
                    internal_name: item.product_name_web,
                    quantity:1,
                    images: item.medium_image_url
                })
            }

            
            this.selectProduct.product_name= item.product_name_web
            this.selectProduct.images = item.medium_image_url
            let quantities = this.selectedProducts.map(obj=>{ return obj.quantity })
            this.setTotalQuantity(quantities.reduce((accumulator, currentValue) => accumulator + currentValue))
            this.itemShoppingCar(this.selectedProducts)
        },

        productInternal(){
            this.productId = this.$route.params.product_id
            if(typeof this.productId != 'undefined'){
                this.setLoadingTable(true)
                this.setUrl(`busqueda-catalogo/${this.$route.params.product_id}`)
                this.setLoadingTable(true)
                this.requestApi({
                    method: 'GET',
                    data :{}
                }).then(res =>{
      
                    
                })
            }
        },

        quantity(operator){

            let itemExist = this.selectedProducts.find(e => e.product_id == this.selectProduct.product_id)

            if(typeof itemExist !='undefined'){

                let index = this.selectedProducts.indexOf(itemExist)
                
                if(operator == '+'){
                    this.selectedProducts[index].quantity+=1
                    this.selectProduct.quantity+=1
                }else{
                    if(this.selectProduct.quantity){
                        this.selectedProducts[index].quantity-=1
                        this.selectProduct.quantity-=1
                    }
                }

            }
            
            let quantities = this.selectedProducts.map(obj=>{
                return obj.quantity
            })

            this.setTotalQuantity(quantities.reduce((accumulator, currentValue) => accumulator + currentValue))
        },

        serachProduct(){
            this.productId=null
            this.setLoadingTable(true)
            this.setUrl('busqueda-catalogo')
            this.requestApi({
				method: 'GET',
				data: {
                    internal_name: this.productText
                }
			}).then(res =>{
                this.totalItems = res.data.page_count
                this.products = res.data._embedded.busqueda_catalogo
			})
        },

        searchCategory(product_category_id){
            this.overlay=true
            this.productId=null
            this.speciality= product_category_id
            this.setLoadingTable(true)
            this.setUrl('busqueda-catalogo')
            this.requestApi({
				method: 'GET',
				data :{
                    esp :product_category_id
                }
			}).then(res =>{
                this.overlay=false
                this.totalItems = res.data.page_count
                this.products = res.data._embedded.busqueda_catalogo
			})
        },  

        redirectShoppingCar(){
            if(this.$vuetify.breakpoint.width <= 959)
            this.productText = this.productText2
            
            if(this.productText!='' && this.productText != null)
                this.$router.push(`/medicamentos-especialidad/${this.productText}`)
            else
                this.$router.push('/medicamentos-especialidad')
           
        },

        redirectRelatedProduct(product_id){
            location.href = `/medicamentos-especialidad/producto/${product_id}`
        },

        saveQrRecord(especialidad,fecha,lab,vendedor){
            
            this.setUrl('registro-web')
            this.requestApi({
				method: 'POST',
				data: {
                    especialidad,
                    fecha,
                    lab,
                    vendedor,
                    typeStore: 'qr'
                }
			})

        }

    },
    mounted(){

       

    },
    beforeUpdate(){
        this.productText= this.$route.params.search
    },
    created(){

        this.productText= this.$route.params.search
        this.$emit('newBreadcrumbs',this.breadcrumbs)
        
        if(this.$route.path=='/medicamentos-especialidad' || this.productText!='')
            this.getDataAutocomplete()
        
        this.overlay=false

        if(this.$route.query.lab != undefined)
            this.titlePage = `LABORATORIO ${this.$route.query.lab.toUpperCase()}`
        else
            this.titlePage = 'MEDICINA DE ESPECIALIDAD'

        if(this.$route.query.especialidad !='' && this.$route.query.especialidad !=null && 
            this.$route.query.fecha!='' && this.$route.query.fecha!=null && 
            this.$route.query.lab!='' && this.$route.query.lab!= null && 
            this.$route.query.vendedor!='' && this.$route.query.vendedor!= null
        ){
            const { especialidad, fecha, lab, vendedor } = this.$route.query
            this.saveQrRecord(especialidad,fecha,lab,vendedor)
        }

    }
}
</script>

<style>
    .filter fieldset {
        border:2px solid #50c995!important
    }

    .search_product > div > div > fieldset {
        border:2px solid #50c995!important
    }

    .v-list--dense .v-list-item, .v-list-item--dense {
        min-height: 22px;
    }
    
    .border-product{
        border-left: 2px solid transparent;
        border-right: 2px solid transparent;
	    -moz-border-image: -moz-linear-gradient(top, #87847b 20%, #fff 100%);
	    -webkit-border-image: -webkit-linear-gradient(top, #fff 20%, #87847b 100%);
	    border-image-slice: 1; 
    } 

    .border-div{
        border-left: 2px solid #87847b;
        border-right: 2px solid #87847b;
        border-bottom: 2px solid #87847b;
        border-bottom-left-radius: 15px!important;
        border-bottom-right-radius: 15px!important;
        position: relative;
        top: -7px;
    }

    .btn-quote{
        border:4px solid;
        position: relative;
        top: 20px;
        background: white!important;
    }

    div.border-div h5{
        height: 100px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .v-application .text-md-h3, .v-application .text-sm-6{
        font-family: Asap!important;
        line-height:1;
    }

    div.link:hover{
        color:#50c995!important
    }

    .v-application--is-ltr .v-expansion-panel-header__icon{
        margin-left: 8px;
    }


</style>
